import { useEffect, useState } from "react";
import { API } from "@/lib/api";

// Fetches admin-editable content overrides once. Pages fall back to static defaults
// when a section is absent, so prerender/SEO always has content.
let _cache = null;
export function useContent() {
  const [content, setContent] = useState(_cache || {});
  useEffect(() => {
    if (_cache) return;
    fetch(`${API}/content`).then((r) => r.json()).then((d) => { _cache = d || {}; setContent(_cache); }).catch(() => {});
  }, []);
  return content;
}
